import React from 'react';
import * as S from './RadioButton.styles';

/**
 * @deprecated Use string literals instead: 'large' or 'small'.
 */
export let RadioButtonSize = /*#__PURE__*/function (RadioButtonSize) {
  RadioButtonSize["LARGE"] = "large";
  RadioButtonSize["SMALL"] = "small";
  return RadioButtonSize;
}({});
const RadioButton = /*#__PURE__*/React.forwardRef(({
  value,
  id,
  label,
  hasError,
  size = 'large',
  disabled
}, ref) => {
  return /*#__PURE__*/React.createElement(S.RadioButtonContainer, {
    "data-disabled": disabled
  }, /*#__PURE__*/React.createElement(S.RadioButtonItem, {
    disabled: disabled,
    value: value,
    id: id,
    ref: ref,
    $error: hasError,
    $size: size
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(S.RadioButtonLabel, {
    $size: size,
    htmlFor: id
  }, label)));
});
export { RadioButton };